import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

const benefits = [
  "Fast approval process - often within 24-48 hours",
  "Transparent terms with no hidden fees",
  "Dedicated support throughout the entire process",
  "Competitive rates tailored to your situation",
];

export default function WhyChooseUsSection() {
  return (
    <section className="py-32 px-6 md:px-12 relative" data-testid="why-choose-us-section">
      <div className="max-w-5xl mx-auto text-center">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-12"
        >
          <div className="mb-6">
            <span className="text-gold text-base font-manrope tracking-wider uppercase">
              WHY CHOOSE US
            </span>
          </div>

          <h2 className="font-playfair text-5xl md:text-6xl font-bold mb-8 text-white">
            Your Success is Our Priority
          </h2>

          <p className="font-manrope text-white/80 text-xl md:text-2xl leading-relaxed max-w-3xl mx-auto">
            With years of experience in the financial industry, we understand
            the unique challenges businesses face. Our dedicated team works
            tirelessly to find the right funding solution for you.
          </p>
        </motion.div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-16">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="glass-card p-8 rounded-xl hover:scale-102 transition-all duration-300"
              data-testid={`benefit-item-${index}`}
            >
              <div className="flex flex-col items-center text-center gap-4">
                <div className="flex-shrink-0 w-14 h-14 rounded-full bg-gold/10 flex items-center justify-center">
                  <CheckCircle2 className="w-8 h-8 text-gold" strokeWidth={2} />
                </div>
                <p className="font-manrope text-white text-lg leading-relaxed">
                  {benefit}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
